import { Pipe, PipeTransform } from '@angular/core';
import { CLUserRole } from './user';

@Pipe({ name: 'cluserrole' })
export class CLUserRolePipe implements PipeTransform {
 
  transform(value: CLUserRole, ...args: any[]) {
    if (value === 'OWNER') {
      return 'Propriétaire';
    }
    else if(value === 'SIMPLE') {
      return 'Simple';
    }
    else {
      return value;
    }
  }
}
